import api from '../api/axios';

export const resolveAuthToken = (jwtToken, accessToken) => {
    return jwtToken || localStorage.getItem('jwtToken') || accessToken || localStorage.getItem('msalToken');
};

export const validateAndSetAuthToken = (token, navigate, toast) => {
    if (!token) {
        console.error('No token available for API request');
        if (toast) {
            toast.error('Authentication token missing. Please login again.');
        }
        if (navigate) {
            navigate('/login');
        }
        return false;
    }

    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return true;
};
